import apiClient from './client';
import { API_BASE_URL, API_ENDPOINTS } from './config';
import type { BookingLinkTokens } from '../types/bookingLink';

// The public booking page is served by the API host itself, so the shareable
// link follows whichever environment this build points at (test vs production).
const PUBLIC_BOOKING_PATH = '/book';

export const bookingLinkApi = {
	/**
	 * Get the public booking tokens for a location.
	 */
	generate: async (locationId: number): Promise<BookingLinkTokens> => {
		return apiClient.post<BookingLinkTokens>(
			`${API_ENDPOINTS.BOOKING_LINK.GENERATE}?locationId=${locationId}`
		);
	},
};

/**
 * Build the customer-facing booking URL for a token.
 */
export const buildBookingUrl = (token: string): string =>
	`${(API_BASE_URL || '').replace(/\/+$/, '')}${PUBLIC_BOOKING_PATH}?token=${encodeURIComponent(token)}`;
